(() => {
  if (customElements.get('reviews-highlight')) return;

  class ReviewsHighlight extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.onWindowLoad = this.onWindowLoad.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.sliderEl = this.querySelector('[data-slider]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      // Pagination lives outside this element so it does not affect the intro's vertical centering
      this.paginationEl = (this.closest('.reviews-highlight') || this).querySelector('[data-pagination]');
      if (!this.sliderEl) return;

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      if (typeof Swiper === 'undefined') {
        if (document.readyState === 'complete') {
          this.initFallback();
        } else {
          window.addEventListener('load', this.onWindowLoad, { once: true });
        }
        return;
      }

      this.initSwiper();
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.onWindowLoad);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.destroySwiper();
    }

    onWindowLoad() {
      if (typeof Swiper === 'undefined') {
        this.initFallback();
        return;
      }
      this.initSwiper();
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const slides = Array.from(this.sliderEl.querySelectorAll('.swiper-slide'));
      const index = slides.findIndex((slide) => slide.contains(event.target));
      if (index < 0) return;

      if (this.swiper) {
        this.swiper.slideTo(index);
      } else {
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    initSwiper() {
      if (this.swiper) return;

      const slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
      if (!slideCount) return;

      this.swiper = new Swiper(this.sliderEl, {
        slidesPerView: 1.16465,
        spaceBetween: 16,
        slidesOffsetAfter: 20,
        breakpointsInverse: true,
        watchOverflow: true,
        grabCursor: true,
        navigation:
          this.prevButton && this.nextButton
            ? {
                prevEl: this.prevButton,
                nextEl: this.nextButton,
              }
            : false,
        pagination: this.paginationEl
          ? {
              el: this.paginationEl,
              clickable: true,
              bulletElement: 'button',
              bulletClass: 'reviews-highlight__bullet',
              bulletActiveClass: 'reviews-highlight__bullet--active',
            }
          : false,
        breakpoints: {
          600: {
            slidesPerView: 1.7,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
          },
          768: {
            slidesPerView: 2.3,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
          },
          1024: {
            slidesPerView: 2.4,
            spaceBetween: 20,
            slidesOffsetAfter: 40,
          },
          1200: {
            slidesPerView: 2.5618,
            spaceBetween: 24,
            slidesOffsetAfter: 40,
          },
        },
      });

      this.classList.add('is-swiper');
      requestAnimationFrame(() => {
        this.swiper?.update();
        this.classList.add('is-initialized');
      });
    }

    // Swiper is only loaded when the theme's new style is enabled; fall back to native scrolling.
    initFallback() {
      this.classList.add('is-fallback', 'is-initialized');
    }

    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
      this.classList.remove('is-swiper', 'is-initialized');
    }
  }

  customElements.define('reviews-highlight', ReviewsHighlight);
})();
